import {PROCESSING, WSError} from "@pledger/frontend-commons";


export const contactWServiceActions = {
    // Création d'une simulation
    REGISTER_CONTACT_ACTION : { type : 'contactWServiceActions.REGISTER_CONTACT_ACTION', build : (captchaAction:string, captchaToken: string,phoneNumber:string,email : string) => {  return { type: contactWServiceActions.REGISTER_CONTACT_ACTION.type, payload: {captchaAction, captchaToken,email,phoneNumber,profilType:'SOCIETE'  }, meta: { request: { status: PROCESSING  } } } }},
    REGISTER_CONTACT_SUCCEEDED_ACTION : { type : 'contactWServiceActions.REGISTER_CONTACT_SUCCEEDED_ACTION', build : (data : {simulationId: string}) => {return {type: contactWServiceActions.REGISTER_CONTACT_SUCCEEDED_ACTION.type,payload: data}}},
    REGISTER_CONTACT_FAILED_ACTION : { type : 'contactWServiceActions.REGISTER_CONTACT_FAILED_ACTION', build : (error : WSError) => {return {type: contactWServiceActions.REGISTER_CONTACT_FAILED_ACTION.type, payload:  error}}},


}
